import React from 'react';
import clsx from 'clsx';
import { Button } from '@shared/ui/buttons/Button';
import { ApplicationCardProps } from './types';
import { IconShow } from '@shared/icons/IconShow';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@hooks/useLanguage';

type ShowReceiptButtonProps = { purchase: ApplicationCardProps['purchase']; className?: string };

function useShowReceiptButtonPropsState({ purchase }: ShowReceiptButtonProps) {
  return { id: purchase?.id } as const;
}

export const ShowReceiptButton = (props: ShowReceiptButtonProps) => {
  const { id } = useShowReceiptButtonPropsState(props);
  const language = useLanguage();
  const { t } = useTranslation();
  if (!id) return null;

  return (
    <Button
      as="link-out"
      variant="secondary"
      size="tiny"
      href={`/${language}/receipts/${id}`}
      icon={IconShow}
      iconClassName="mr-3"
      className={clsx('inline-flex text-center', props.className)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('show-receipt')}
    </Button>
  );
};
